module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth.component.html
// module id = ./src/app/auth/auth.component.html
// module chunks = main